const DialogStyles = theme => ({
  paper: {
    overflowX: "hidden",
    [theme.breakpoints.down("sm")]: {
      margin: 24
    }
  },
  header: {
    backgroundColor: "#303030",
    color: "#fff",
    textAlign: "center",
    padding: [[48, 56, 40, 56]],
    [theme.breakpoints.down("sm")]: {
      padding: "48px 16px 24px 16px"
    },
    "& h3": {
      fontWeight: 300,
      marginBottom: 16,
      opacity: 0.94,
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.6rem"
      }
    }
  },
  compact: {
    "& $header": {
      padding: 16,
      textAlign: "left",
      "& h3": {
        position: "absolute",
        top: "14px",
        left: "60px",
        fontSize: "1.2rem",
        lineHeight: "1.6em",
        fontWeight: 400,
        letterSpacing: "0.6px"
      }
    },
    "& $closeBtn": {
      fontSize: 24
    }
  },
  compactTitle: {
    marginBottom: 16
  },
  logo: {
    width: 26
  },
  closeBtn: {
    color: "#fff",
    opacity: 0.94,
    fontSize: 28,
    cursor: "pointer",
    position: "absolute",
    top: "16px",
    right: "16px",
    "&:hover": {
      opacity: 0.9
    },
    "&:focus": {
      outline: "none"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 24
    }
  }
});

const commonStyles = theme => ({
  paper: {
    overflowX: "hidden",
    [theme.breakpoints.down("sm")]: {
      margin: 24
    }
  },
  header: {
    backgroundColor: "#303030",
    color: "#fff",
    textAlign: "center",
    padding: [[48, 56, 40, 56]],
    [theme.breakpoints.down("sm")]: {
      padding: "48px 16px 24px 16px"
    },
    "& h3": {
      fontWeight: 300,
      marginBottom: 16,
      opacity: 0.94,
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.6rem"
      }
    }
  },
  compact: {
    "& $header": {
      padding: 16,
      textAlign: "left",
      "& h3": {
        display: "none"
      }
    },
    "& $closeBtn": {
      fontSize: 24
    }
  },
  logo: {
    width: 26
  },
  content: {
    width: "100%",
    display: "flex",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      height: "initial",
      flexDirection: "column"
    },
    "& p": {
      textAlign: "justify",
      marginTop: 0,
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.875rem"
      }
    }
  },
  instruction: {
    marginBottom: 16
  },
  container: {
    padding: 48,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-around",
      flexWrap: "wrap",
      padding: 16,
      flexDirection: "row"
    }
  },
  title: {
    fontSize: "2rem",
    marginBottom: 8
  },
  actionContainer: {
    backgroundColor: "#f6f9fc",
    opacity: 1,
    transition: "all 800ms ease-in-out",
    transitionDelay: "1000ms",
    "& form": {
      width: "95%",
      marginBottom: 16,
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    "& p": {
      width: "100%"
    }
  },
  actionSuccess: {
    transform: "translateX(100%)",
    opacity: 0
  },
  actionForm: {
    marginBottom: 24,
    textAlign: "center"
  },
  actionBtn: {
    textAlign: "center",
    marginTop: 24,
    [theme.breakpoints.down("sm")]: {
      marginTop: 8
    }
  },
  actionBtnRoot: {
    textTransform: "initial"
  },
  fieldPaper: {
    width: 320,
    marginBottom: 12,
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  label: {
    position: "relative",
    display: "flex",
    height: 48,
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid #f0f5fa",
    "&:last-child": {
      borderBottom: "none"
    },
    [theme.breakpoints.down("sm")]: {
      height: 40
    }
  },
  labelText: {
    minWidth: 125,
    padding: "0 15px"
  },
  field: {
    flex: 1,
    padding: "0 15px",
    color: "#31325f",
    outline: "none",
    cursor: "text",
    borderStyle: "none",
    "&:-webkit-autofill": {
      "-webkit-text-fill-color": "#666ee8",
      transition: "background-color 100000000s",
      "-webkit-animation": "1ms void-animation-out 1s"
    },
    "&:disabled": {
      cursor: "default",
      backgroundColor: "white"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem"
    }
  },
  errorMessage: {
    fontSize: "0.75rem",
    lineHeight: "1.375em",
    color: "#f50057",
    textAlign: "left",
    width: "100%",
    maxWidth: 320,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "initial"
    }
  },
  successContainer: {
    padding: 32,
    position: "absolute",
    bottom: "999px",
    right: "999px",
    width: "50%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    transition: "opacity 800ms ease-in-out",
    transitionDelay: "1200ms",
    "& >div": {
      width: 400,
      paddingBottom: 36
    }
  },
  successDisplay: {
    bottom: "0px",
    right: "0px",
    opacity: 1,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "50%"
    }
  },
  fullWidthSuccessContainer: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      height: "initial"
    }
  },
  successMessage: {
    margin: 0,
    marginBottom: 12
  },
  successCaption: {
    margin: 0,
    color: "rgba(0,0,0,0.54)"
  },
  closeBtn: {
    color: "#fff",
    opacity: 0.94,
    fontSize: 28,
    cursor: "pointer",
    position: "absolute",
    top: "16px",
    right: "16px",
    "&:hover": {
      opacity: 0.9
    },
    "&:focus": {
      outline: "none"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 24
    }
  },
  link: {
    fontSize: "0.9375rem",
    textTransform: "initial",
    textDecoration: "underline",
    fontWeight: 400,
    cursor: "pointer",
    color: "#2296f3",
    "&:visited": { color: "#2296f3" },
    "&:hover": { color: "#2296f3", opacity: 0.9 }
  }
});

const youtubeDialogStyles = () => ({
  root: {
    overflow: "hidden"
  },
  padding: {
    width: "100%",
    paddingTop: "56.25%"
  },
  playerCtn: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "hidden",
    backgroundColor: "#000"
  }
});

const notSupportDialogStyles = theme => ({
  content: {
    padding: 48
  },
  description: {
    maginBottom: 16
  },
  browsersContainer: {
    width: "100%"
  },
  browser: {
    display: "inline-block",
    textAlign: "center",
    marginTop: 8,
    "& p": {
      textAlign: "center"
    }
  },
  browserImg: {
    width: "50%",
    marginBottom: 8
  }
});

const subscriptionDialogStyles = theme => ({
  ...commonStyles(theme),
  paper: {
    maxWidth: 416,
    width: "100%",
    overflowX: "hidden",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      margin: 24
    }
  }
});

const getCopyDialogStyles = theme => ({
  ...commonStyles(theme),
  paper: {
    maxWidth: 1024,
    width: "100%",
    overflowX: "hidden",
    position: "relative",
    display: "block"
  },
  previewContainer: {
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  preview: {
    width: "100%",
    paddingBottom: "71.4%",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    marginBottom: 16,
    [theme.breakpoints.down("sm")]: {
      width: 300,
      height: 300 / 1.4
    }
  },
  features: {
    listStyle: "none",
    paddingLeft: 0,
    "& li": {
      fontWeight: 300,
      color: "#6b7c93",
      marginBottom: 12
    }
  }
});

const stripeCardStyle = {
  base: {
    ":disabled": {
      color: "#31325f"
    }
  }
};
export {
  DialogStyles,
  commonStyles,
  notSupportDialogStyles,
  subscriptionDialogStyles,
  youtubeDialogStyles,
  getCopyDialogStyles,
  stripeCardStyle
};



// WEBPACK FOOTER //
// ./src/components/Dialogs/styles.js